import { gql } from '@apollo/client';

export const GET_UPERCUT_PERMISSIONS = gql`
    query getUpercutPermissions {
        upercutPermissions {
            _id
            name
            resource
            action
            scope
            description
        }
    }
`;

export const GET_UPERCUT_ROLES = gql`
    query getUpercutRoles($filter: UpercutRoleFilterInput) {
        upercutRoles(filter: $filter) {
            _id
            name
            slug
            description
            isSystemRole
            permissions {
                _id
                name
                resource
                action
                scope
            }
        }
    }
`;

export const GET_UPERCUT_PERMISSION_AUDITS = gql`
    query getUpercutPermissionAudits($upercutId: ID, $eventType: AuditEventType) {
        upercutPermissionAudits(upercutId: $upercutId, eventType: $eventType) {
            _id
            eventType
            upercutId
            targetUpercutId
            roleId
            permissionId
            success
            errorMessage
            timestamp
        }
    }
`;

export const GET_UPERCUT_USER_PERMISSIONS = gql`
    query getUpercutUserPermissions {
        upercutUserPermissions
    }
`;

export const GET_UPERCUT_USER_ROLES = gql`
    query getUpercutUserRoles($filter: UpercutUserRoleFilterInput) {
        upercutUserRoles(filter: $filter) {
            _id
            upercutId
            roleId {
                _id
                name
                slug
            }
            assignedBy
            assignedAt
            isActive
            expiresAt
        }
    }
`;

export const CREATE_UPERCUT_ROLE = gql`
    mutation createUpercutRole($input: CreateUpercutRoleInput!) {
        createUpercutRole(input: $input) {
            _id
            name
            slug
            description
            isSystemRole
            permissions {
                _id
                name
            }
        }
    }
`;

export const UPDATE_UPERCUT_ROLE = gql`
    mutation updateUpercutRole($id: ID!, $input: UpdateUpercutRoleInput!) {
        updateUpercutRole(id: $id, input: $input) {
            _id
            name
            slug
            description
            isSystemRole
            permissions {
                _id
                name
            }
        }
    }
`;

export const DELETE_UPERCUT_ROLE = gql`
    mutation deleteUpercutRole($id: ID!) {
        deleteUpercutRole(id: $id)
    }
`;

export const ASSIGN_UPERCUT_ROLE = gql`
    mutation assignUpercutRole($input: AssignUpercutRoleInput!) {
        assignUpercutRole(input: $input) {
            _id
            upercutId
            assignedBy
            assignedAt
            role {
                _id
                name
            }
        }
    }
`;

export const UPERCUT_USER_ROLE_CHANGED = gql`
    subscription upercutUserRoleChanged($upercutId: ID!) {
        upercutUserRoleChanged(upercutId: $upercutId) {
            _id
            upercutId
            role {
                _id
                name
            }
        }
    }
`;

export const UPERCUT_PERMISSION_SYSTEM_CHANGED = gql`
    subscription upercutPermissionSystemChanged {
        upercutPermissionSystemChanged {
            eventType
            timestamp
        }
    }
`;

export const CREATE_UPERCUT_PERMISSION = gql`
    mutation createUpercutPermission($input: CreateUpercutPermissionInput!) {
        createUpercutPermission(input: $input) {
            _id
            name
            resource
            action
            scope
            description
            createdAt
            updatedAt
        }
    }
`;

export const UPDATE_UPERCUT_PERMISSION = gql`
    mutation updateUpercutPermission($id: ID!, $input: UpdateUpercutPermissionInput!) {
        updateUpercutPermission(id: $id, input: $input) {
            _id
            name
            resource
            action
            scope
            description
            createdAt
            updatedAt
        }
    }
`;

export const DELETE_UPERCUT_PERMISSION = gql`
    mutation deleteUpercutPermission($id: ID!) {
        deleteUpercutPermission(id: $id)
    }
`;
